import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import Action from '@/store/actions-types'

import Btn from '@/components/btn'
import MainBtn from '@/components/main-btn'

import VueObserveVisibility from 'vue-observe-visibility'
import Fragment from 'vue-fragment'
import { gsap } from 'gsap'
import { CustomEase } from 'gsap/CustomEase'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faICursor, faHandPointer } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import '@/assets/styles/tailwind.sass'
import '@/assets/fonts/font-faces.css'

import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

gsap.registerPlugin(CustomEase)
gsap.registerPlugin(ScrollToPlugin)

Vue.component('btn', Btn)
Vue.component('main-btn', MainBtn)
Vue.use(VueObserveVisibility)
Vue.use(Fragment.Plugin)
Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(faICursor, faHandPointer)

extend('email', email)
extend('required', required)

Vue.config.productionTip = false
Vue.prototype.$TOGGLE_MENU = Action.TOGGLE_MENU
Vue.prototype.$TOGGLE_DIRECTION = Action.TOGGLE_DIRECTION
Vue.prototype.$CHANGE_CURSOR_STATE = Action.CHANGE_CURSOR_STATE
Vue.prototype.$GET_VIEWPORT_DIMENSIONS = Action.GET_VIEWPORT_DIMENSIONS
Vue.prototype.$SET_CURRENT_PREVIEW = Action.SET_CURRENT_PREVIEW
Vue.prototype.$SET_DID_SEE_INTRO_ANIM = Action.SET_DID_SEE_INTRO_ANIM
Vue.prototype.$SET_DID_SHOW_SELECTOR_PRESENTER = Action.SET_DID_SHOW_SELECTOR_PRESENTER
Vue.prototype.$SET_DID_WATCH_INTRO_ANIM_IN_SECTION = Action.SET_DID_WATCH_INTRO_ANIM_IN_SECTION
Vue.prototype.$SET_TOGGLE_CONTACT_MODAL_OPEN = Action.SET_TOGGLE_CONTACT_MODAL_OPEN
Vue.prototype.$SET_DID_SEE_DRAG_TOOLTIP = Action.SET_DID_SEE_DRAG_TOOLTIP
export const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
